import React from "react";
import useQueryParams from "./useQueryParams";

const withQueryParams = (options = {}) => {
    return (WrappedComponent) => {
        const WithComponent = (props) => {
            const queryParams = useQueryParams();
            const newProps = {
                ...props,
                ...queryParams,
            };
            return React.createElement(WrappedComponent, newProps);
        };

        return WithComponent;
    };
};

export default withQueryParams;
